module.exports = __webpack_public_path__ + "img/bg@3x.167e80ae.png";